import LoanDeposit from './views/index.c';

export default LoanDeposit;
